<template>
  <section id="reset">
    <div class="container">
      <div class="logo-cont">
        <div class="logo">
          <GridxLogo />
        </div>
      </div>

      <form id="app" @submit="onReset" action="https://vuejs.org/" method="post">
        <div class="login-fields col-12 col-md-6 offset-md-3">
          <h1>Crear nueva contraseña</h1>
          <NormalInput
            labelBg="#fbfafd"
            name="password"
            label="Nueva contraseña"
            type="password"
            v-model="password"
          />
          <NormalInput
            labelBg="#fbfafd"
            name="passwordRepeat"
            label="Repetir contraseña"
            type="password"
            v-model="passwordRepeat"
          />
          <p class="error">{{error}}</p>
        </div>

        <div class="col-12 col-md-6 offset-md-3 login-button-container">
          <PrimaryButton @click="onReset" class="login-button">{{resetButtonText}}</PrimaryButton>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import GridxLogo from '../assets/icons/gridx-logo-b.svg';
import NormalInput from '../components/Input/NormalInput.vue';
import PrimaryButton from '../components/Button/PrimaryButton.vue';

export default {
  name: 'Login',
  components: {
    GridxLogo,
    NormalInput,
    PrimaryButton,
  },
  data() {
    return {
      password: '',
      passwordRepeat: '',
      error: '',
      resetButtonText: 'CREAR CONTRASEÑA',
    };
  },
  methods: {
    async onReset() {
      this.error = '';
      if (this.password !== this.passwordRepeat) {
        this.error = 'Las contraseñas no coinciden';
        return;
      }

      this.$store.commit('toggleLoadingBar', true);

      this.resetButtonText = 'CARGANDO...';

      try {
        const formData = new FormData();
        formData.append('password', this.password);

        const response = await fetch(`https://gridxbackend.dreamhosters.com/api/login/reset/${this.$route.params.token}`, {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          this.$store.commit('toggleLoadingBar', false);
          this.resetButtonText = 'CREAR CONTRASEÑA';
          this.error = 'Ocurrió un error con la petición';
          return;
        }

        const data = await response.json();

        this.$store.commit('toggleLoadingBar', false);

        localStorage.setItem('gridx_app_token', data.data.access_token);

        this.$router.push({ name: 'Home' });
      } catch (e) {
        this.$store.commit('toggleLoadingBar', false);
        this.resetButtonText = 'CREAR CONTRASEÑA';
        this.error = 'Ocurrió un error con la petición';
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
};
</script>

<style lang="scss" scoped>
#reset {
  height: 100vh;
  background: #fbfafd;
  overflow: hidden;
  padding-top: 50px;

  h1 {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    color: #330e2f;
  }
}

.logo-cont {
  height: 185px;
}

.logo {
  display: block;
  margin: 0 auto;
  position: relative;
  padding-top: 100px;
  height: 29px;
  svg {
    margin: 0 auto;
    display: block;
    height: 29px;
  }
}

.login-bg {
  position: absolute;
  right: 15px;
  max-width: 752px;
}

.login-fields {
  margin-top: 30px;
}

.login-button-container {
  margin-top: 20vh;
}

.login-button {
  width: 100%;
}

.error {
  font-size: 16px;
  color: #ff5f3c;
  position: absolute;
}

.forgot-password {
  float: right;
  margin-top: 10px;
}
</style>
